export default __webpack_public_path__ + "static/media/nl_NL.37f17557.svg";